document.addEventListener("DOMContentLoaded", () => {

    const overlay = document.getElementById("ai-search-overlay");
    const openBtn = document.getElementById("open-search");
    const closeBtn = document.getElementById("close-search");
    const toggleBtn = document.getElementById("mobile_search_toggle");
    const form = document.getElementById("ai-search-form");
    const resultsDiv = document.getElementById("results");

    // --- Overlay open/close ---
    if (openBtn) openBtn.addEventListener("click", () => overlay.style.display = "flex");
    if (closeBtn) closeBtn.addEventListener("click", () => overlay.style.display = "none");
    if (overlay) overlay.addEventListener("click", e => {
        if (e.target === overlay) overlay.style.display = "none";
    });
    if (toggleBtn) toggleBtn.addEventListener("click", () => {
        const isOpen = overlay.style.display === "flex";
        overlay.style.display = isOpen ? "none" : "flex";
    });

    // --- Fetch product info from meta tags ---
    async function getProductFromPage(url) {
        try {
            // Ensure full URL for fetch
            if (url.startsWith("/")) url = window.location.origin + url;

            const res = await fetch(url);
            if (!res.ok) return null;

            const text = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "text/html");

            const title = doc.querySelector('meta[property="og:title"]')?.content || "";
            const price = doc.querySelector('meta[property="product:price:amount"]')?.content || "";
            const currency = doc.querySelector('meta[property="product:price:currency"]')?.content || "";
            const image = doc.querySelector('meta[property="og:image"]')?.content || "";

            return {
                title,
                price,
                currency,
                image,
                url
            };
        } catch (e) {
            console.error("Error fetching product page", url, e);
            return null;
        }
    }

    // --- Search submit handler ---
    if (form && resultsDiv) {
        form.addEventListener("submit", async e => {
            e.preventDefault();
            const query = document.getElementById("searchQuery").value;
            resultsDiv.innerHTML = `<p><em>${translations["ai-search-searching"]}</em></p>`;

            document.querySelectorAll(".pre-search-ai").forEach(el => el.style.display = "none");


            try {
                const response = await fetch("https://regencychess.co.uk/ai-search/search.php", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        query
                    }),
                });
                const data = await response.json();

                let html = "";

                if (data.results && data.results.length > 0) {
                    const productCards = await Promise.all(
                        data.results.map(async item => {
                            // Always prepend /products/ if no full URL provided
                            const product = await getProductFromPage(item.Url || `/products/${item.Handle}`);
                            if (!product) return "";

                            return `
                <div class="col-1-5 hwm mb20 centeredContent">
                  <div class="product_box smooth pad_bottom rel">
                    <div class="product_box_image rel mb20">
                      <a href="/products/${item.Handle}">
                        <img src="${product.image}" alt="${product.title}" width="400" height="320" loading="lazy">
                      </a>
                    </div>
                    <div>
                      <p class="mb10"><a href="/products/${item.Handle}" class="bold burgundy">${product.title}</a></p>
                      <span class="serif"><div class="productSpecialPrice largest">${product.currency} ${product.price}</div></span>
                      <div class="clear product_box_buttons centeredContent"><a href="/products/${item.Handle}" class="green_gradient" style="width:100%">${translations["ai-search-view-product"]}</a></div>
                    </div>
                  </div>
                </div>
              `;
                        })
                    );

                    html += `<button class="ai-search-reload">${translations["ai-search-try-another"]}</button>`;

                    if (data.params) {
                        const toTitleCase = str =>
                            str
                            .toLowerCase()
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, char => char.toUpperCase());

                        const entries = Object.entries(data.params)
                            .map(([key, val]) => {
                                // Attempt to translate the key

                                console.log("pre translated key: " + key);
                                const def = `ai-search-${key.replace(/_/g, "-")}`;
                                console.log(def);
                                const keyTranslation = translations[def];
                                const cleanKey = keyTranslation || toTitleCase(key);
                                console.log("translated key: " + keyTranslation);

                                console.log("pre translated value: " + val)
                                const def2 = `ai-search-${String(val).toLowerCase().replace(/[ _]/g, "-")}`;
                                console.log(def2);
                                const valueTranslation = translations[def2];
                                const cleanVal = valueTranslation || toTitleCase(String(val));
                                console.log("translated value: " + valueTranslation);

                                return `<span><strong>${cleanKey}</strong>: ${cleanVal}</span>`;
                            })
                            .join(" ");

                        html += `<div style="margin-bottom:1rem; display:flex; flex-wrap:wrap; gap:10px; justify-content: center;">${entries}</div>`;
                    }

                    html += `<p style="text-align: center; color: #7b0008; font-weight: bold; font-size: 20px;">
           <strong>${translations["ai-search-we-found"].replace("{x}", data.results.length)}</strong>
         </p>`;

                    html += `<div class="clear nudge flex" style="margin-bottom:20px;">${productCards.join("")}</div>
                   <button class="ai-search-reload">${translations["ai-search-try-another"]}</button>`;
                } else html += `<p>${translations["ai-search-no-results"]}</p> <button class="ai-search-reload"></button>`;

                resultsDiv.innerHTML = html;

            } catch (err) {
                console.error(err);
                resultsDiv.innerHTML = `<p style='color:red;'>${translations["ai-search-error-fetching"]}</p>`;
            }
        });
    }

    // --- Reload search ---
    document.addEventListener("click", e => {
        if (e.target.classList.contains("ai-search-reload")) {
            e.preventDefault();

            document.querySelectorAll(".pre-search-ai").forEach(el => el.style.display = "block");

            resultsDiv.innerHTML = "";
            form.reset();
            document.getElementById("searchQuery").focus();
        }
    });

});